import * as React from 'react';
import { Loyalty as LoyaltyRoot } from '../../../../../../CheckoutAdditionalService/components';
import { getServicesAggregation } from '../../../../../../ServicesAggregation/context';
import { Star } from '../../../../../../Icons';
const Loyalty = () => {
    const { userInfo, refetchUser } = getServicesAggregation();
    return React.createElement(LoyaltyRoot, { userInfo: userInfo, refetchUser: refetchUser, aggregationIcons: [Star], aggregationMode: true });
};
export default Loyalty;
